export type ItemStatus = "past" | "current" | "future";

export function classify(startUtc: string, endUtc: string, now: number): ItemStatus {
  const s = Date.parse(startUtc);
  const e = Date.parse(endUtc);
  if (now < s) return "future";
  if (now > e) return "past";
  return "current";
}
